let elements = document.getElementsByClassName("taen-blokk");


if (elements === undefined || elements.length == 0) {

} else {
    for (let i = 0; i < elements.length; i++) {
        let id = elements.item(i).dataset.lrid;
        let right = document.getElementById("right-"+id);
        let left = document.getElementById("left-"+id);
        if (i % 2 == 0) {
            left.classList.add("cell");
            left.classList.add("medium-6");
        } else {
            right.classList.add("cell");
            right.classList.add("medium-6");
        }
        elements.item(i).style.opacity = 1;
    }

    (function($) {

        /**
         * Copyright 2012, Digital Fusion
         * Licensed under the MIT license.
         * http://teamdf.com/jquery-plugins/license/
         *
         * @author Sam Sehnert
         * @desc A small plugin that checks whether elements are within
         *     the user visible viewport of a web browser.
         *     only accounts for vertical position, not horizontal.
         */
      
        $.fn.visible = function(partial) {
          
            var $t            = $(this),
                $w            = $(window),
                viewTop       = $w.scrollTop(),
                viewBottom    = viewTop + $w.height(),
                _top          = $t.offset().top,
                _bottom       = _top + $t.height(),
                compareTop    = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;
          
          return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
      
        };
          
    })(jQuery);

    var win = jQuery(window);
    var allMods = jQuery(".taen-blokk");

    // Already visible modules
    allMods.each(function(i, el) {
        var el = jQuery(el);
        if (el.visible(true)) {
            el.addClass("taen-already-visible"); 
        } 
    });

    win.scroll(function(event) {
    
        allMods.each(function(i, el) {
            var el = jQuery(el);
            if (el.visible(true)) {
            el.addClass("taen-come-in"); 
            } 
        });
    
    });

}

